export interface ErrorMessageProps {
  errorMessage?: string | null;
}

export default function ErrorMessage({errorMessage}: ErrorMessageProps) {
  if (!errorMessage) return null;

  return <div className="border-primary bg-primary/10 border-l-4 p-4">{errorMessage}</div>;
}
